import type { FC } from 'react';
import CupIcon from '../../_/cup.svg?react';

export const WineDetailItem: FC<{
  title: string;
  value: string | number | null | undefined;
}> = ({ title, value }) => {
  return (
    <div className="flex gap-3 items-center">
      <div className="flex items-center justify-center rounded-full bg-purple-100 w-10 h-10">
        <CupIcon className="w-6 h-6 text-purple-500" />
      </div>
      <div className="flex flex-col gap-0.5">
        <span className="text-sm text-gray-500">{title}</span>
        <span className="text-lg font-bold">{value || '-'}</span>
      </div>
    </div>
  );
};
